// ProjectSelect.jsx
import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export default function ProjectSelect({ options, value, onChange, errorText, required, disabled = false }) {
  return (
    <div className="form-input-expense" style={{ marginTop: 20 }}>
      <label className="form-input-label-expense">Project*</label>
      <Autocomplete
        options={options}
        getOptionLabel={(opt) => opt?.name ?? ''}
        value={value}
        onChange={onChange}
        disablePortal
        fullWidth
        className="mui-input"
        // Ensure equality by ID (string-safe)
        isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Search project..."
            error={!!errorText}
            helperText={errorText || ''}
            required={required}
          />
        )}
        disabled={disabled}
      />
    </div>
  );
}
